var _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgChartIconArea(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_42964",
    "data-name": "Group 42964",
    transform: "translate(-29 -200)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_42947",
    "data-name": "Group 42947",
    transform: "translate(-387 -125)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_42607",
    "data-name": "Group 42607",
    transform: "translate(416 325)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_6222",
    "data-name": "Rectangle 6222",
    fill: "#fff",
    stroke: "#dedede",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    rx: 4,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 29,
    height: 29,
    rx: 3.5,
    fill: "none"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Horizontal_bar_chart",
    "data-name": "Horizontal bar chart",
    transform: "translate(419.947 328.947)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_58",
    "data-name": "Rectangle 58",
    width: 22.105,
    height: 22.105,
    transform: "translate(0.053 0.053)",
    fill: "#85888a",
    opacity: 0
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_42960",
    "data-name": "Group 42960",
    transform: "translate(-1)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_70241",
    "data-name": "Path 70241",
    d: "M-1.226,285.09v16h16",
    transform: "translate(38.226 -78.09)",
    fill: "none",
    stroke: "#85888a",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("g", {
    id: "noun_Graph_868133",
    transform: "translate(40.158 208.67)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_70444",
    "data-name": "Path 70444",
    d: "M15.586,12.793l2.793,1.4L21.173,10V21.173H10V15.586l2.793,1.4Z",
    transform: "translate(-10 -10)",
    fill: "none",
    stroke: "#85888a",
    strokeLinejoin: "round",
    strokeWidth: 1.3
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChartIconArea);
export default __webpack_public_path__ + "static/media/chart-icon-area.60d73a31.svg";
export { ForwardRef as ReactComponent };